export interface Book {
  id: number;
  slug: string;
  title: string;
  subtitle: string;
  description?: string;
  cover: string;
  oldPrice: number;
  price: number;
  rating: number;
  reviews: number;
  pages: number;
  readers?: string;
  format: string;
  benefits: Array<{
    icon: string;
    title: string;
    description: string;
  }>;
  chapters: Array<{
    number: string;
    title: string;
    lessons: number;
    duration: string;
  }>;
  testimonials: Array<{
    name: string;
    role: string;
    school: string;
    photo: string;
    text: string;
    rating: number;
  }>;
  faqs: Array<{
    question: string;
    answer: string;
  }>;
  amazonLink: string;
  kiwifyLink: string;
}

export const booksData: Book[] = [
  {
    id: 1,
    slug: 'universo-magico-brincadeiras',
    title: 'O Universo Mágico das Brincadeiras - Aprendizagem Lúdica na Primeira Infância - 2ª edição',
    subtitle: 'Conecte com a criança',
    description: 'O Universo Mágico das Brincadeiras: Aprendizagem Lúdica na Primeira Infância é um guia essencial para educadores, pais e profissionais da educação que desejam compreender, com base científica e aplicação prática, como o brincar se afirma como o principal motor do desenvolvimento infantil.\n\nCom mais de 17 anos de experiência em sala de aula, Sergio Barros apresenta uma abordagem acessível e fundamentada que integra neurociência, psicologia do desenvolvimento e pedagogia contemporânea, demonstrando que a brincadeira é um conjunto de estratégias pedagógicas intencionais, capazes de desenvolver competências cognitivas, socioemocionais e motoras desde os primeiros anos de vida.\n\nAo longo da obra, o leitor encontrará reflexões e exemplos práticos sobre o impacto do brincar no desenvolvimento cerebral, a relação entre ludicidade, aprendizagem significativa e motivação, o papel do educador como designer de experiências lúdicas, a avaliação por meio da observação e do brincar, além de temas como inclusão, criatividade e preparação para a vida adulta.\n\nCom linguagem clara e narrativa envolvente, fundamentada em autores como John Hattie, B. F. Skinner e Vygotsky, o livro conecta teoria e prática, oferecendo estudos de caso e orientações aplicáveis ao contexto escolar e familiar.\n\nIndicado para educadores, gestores, estudantes de pedagogia e famílias, O Universo Mágico das Brincadeiras é uma leitura indispensável para quem deseja educar com intencionalidade, afeto e evidência científica, transformando o brincar em uma poderosa ferramenta de aprendizagem para o século XXI.',
    cover: '/images/ebook-universo-magico.jpg',
    oldPrice: 37,
    price: 9.9,
    rating: 4.9,
    reviews: 342,
    pages: 287,
    format: 'E-book PDF',
    benefits: [
      {
        icon: 'ri-lightbulb-line',
        title: 'Metodologias Comprovadas',
        description: 'Técnicas validadas por mais de 200 escolas em todo o Brasil'
      },
      {
        icon: 'ri-team-line',
        title: 'Gestão de Equipes',
        description: 'Como liderar professores e coordenadores com excelência'
      },
      {
        icon: 'ri-line-chart-line',
        title: 'Resultados Mensuráveis',
        description: 'Indicadores práticos para acompanhar o crescimento da sua escola'
      },
      {
        icon: 'ri-book-open-line',
        title: 'Casos Reais',
        description: 'Estudos de caso detalhados de transformações educacionais'
      },
      {
        icon: 'ri-shield-check-line',
        title: 'Compliance Educacional',
        description: 'Adequação às normas da BNCC e legislação vigente'
      },
      {
        icon: 'ri-parent-line',
        title: 'Relação Escola-Família',
        description: 'Estratégias para engajar pais no processo educativo'
      }
    ],
    chapters: [
      {
        number: '01',
        title: 'Fundamentos da Liderança Educacional',
        lessons: 12,
        duration: '45 min'
      },
      {
        number: '02',
        title: 'Gestão Estratégica de Pessoas',
        lessons: 15,
        duration: '60 min'
      },
      {
        number: '03',
        title: 'Indicadores de Performance Escolar',
        lessons: 10,
        duration: '40 min'
      },
      {
        number: '04',
        title: 'Comunicação Não-Violenta na Escola',
        lessons: 8,
        duration: '35 min'
      },
      {
        number: '05',
        title: 'Inovação Pedagógica Aplicada',
        lessons: 14,
        duration: '55 min'
      }
    ],
    testimonials: [
      {
        name: 'Maria Helena Santos',
        role: 'Diretora Pedagógica',
        school: 'Colégio Excelência - SP',
        photo: '/images/sergio-barros.jpg',
        text: 'Este livro transformou completamente minha forma de gerir a equipe. Em 6 meses, nossa taxa de retenção de alunos subiu 34%.',
        rating: 5
      },
      {
        name: 'Carlos Eduardo Lima',
        role: 'Coordenador Pedagógico',
        school: 'Instituto Educacional - RJ',
        photo: '/images/sergio-barros.jpg',
        text: 'Metodologias práticas que realmente funcionam. Consegui implementar mudanças significativas já na primeira semana.',
        rating: 5
      },
      {
        name: 'Ana Paula Rodrigues',
        role: 'Gestora Escolar',
        school: 'Escola Inovação - MG',
        photo: '/images/sergio-barros.jpg',
        text: 'Investimento que se paga sozinho. As estratégias de engajamento familiar aumentaram nossa captação em 40%.',
        rating: 5
      }
    ],
    faqs: [
      {
        question: 'O e-book é em PDF ou preciso de internet para ler?',
        answer: 'É um PDF de alta qualidade que você baixa imediatamente após a compra. Pode ler offline em qualquer dispositivo.'
      },
      {
        question: 'Funciona para escolas pequenas ou só para grandes instituições?',
        answer: 'As metodologias são escaláveis e funcionam desde escolas com 50 alunos até grandes redes educacionais. Há exemplos práticos para todos os portes.'
      },
      {
        question: 'Quanto tempo leva para ler o livro completo?',
        answer: 'O livro tem 287 páginas e pode ser lido em aproximadamente 4-5 horas. Mas é um material de consulta permanente que você vai revisitar constantemente.'
      },
      {
        question: 'Posso compartilhar com minha equipe?',
        answer: 'A licença é individual. Para uso institucional, oferecemos pacotes corporativos com desconto. Entre em contato para saber mais.'
      },
      {
        question: 'Como funciona a garantia de 7 dias?',
        answer: 'Se por qualquer motivo você não ficar satisfeito, basta enviar um email em até 7 dias e devolvemos 100% do seu investimento, sem perguntas.'
      }
    ],
    amazonLink: 'https://www.amazon.com.br/Universo-M%C3%A1gico-das-Brincadeiras-Aprendizagem-ebook/dp/B0GC98GLV7/ref=sr_1_1?__mk_pt_BR=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=3V1ZH0HP6C7AC&dib=eyJ2IjoiMSJ9.xe07Nm8SiVoMP1i127UOTWIIUrFvuPiEF3g1rouMTbWCMVft9HBc60jFipqXmdKtbS-9Ktn8XQV_w1h0_MUD5KYkv6W8sDZgKzBoI2n0MmuzBJOns9U6RUiKVfwJryoxRxHG-gv2njDSosb0aPCk8g.c_9_VdXyPG4_vrToyWe_yGfmoN2-SF9yIzlWcriyECo&dib_tag=se&keywords=o+universo+m%C3%A1gico+das+brincadeiras&qid=1774347610&sprefix=o+universo+m%C3%A1gico+das+brincadeiras%2Caps%2C581&sr=8-1',
    kiwifyLink: '#'
  },
  {
    id: 2,
    slug: 'emocoes-em-movimento',
    title: 'Emoções em Movimento - Inteligência Emocional Para Crianças de 0 a 6 Anos Volume 1',
    subtitle: 'A Engenharia da Alma para a Primeira Infância',
    description: 'Em sua obra Emoções em Movimento, o Professor Sergio decreta o fim da mediocridade no sistema educativo. Ele defende que criar crianças apenas "comportadas" é uma tarefa simplista; o verdadeiro triunfo reside em formar indivíduos íntegros, resilientes e senhores de si. Através do mapa definitivo para a "Educação da Vontade", o autor ensina o adulto a se tornar a âncora fisiológica necessária em meio ao caos moderno, construindo pontes neurais sólidas onde outros enxergam apenas conflitos intransponíveis.\n\nO Professor Sergio mergulha profundamente na fase crucial entre os 0 e 6 anos, período em que o cérebro infantil é um campo de batalha constante entre a "Fera" instintiva e o "Sábio" em formação. Unindo a autoridade técnica de um Head of Education à vivência prática e visceral de um pai solo, ele revela a alquimia necessária para transformar birras em resiliência. Fundamentado em pilares como Winnicott e Payot, além dos avanços da neurociência sobre o córtex pré-frontal, o autor decifra o que chama de "Wi-Fi da Alma", ensinando a utilizar os neurônios-espelho para corregular o sistema nervoso da criança.\n\nMais do que um tratado teórico, esta obra é um treinamento de elite. O Professor Sergio guia pais e educadores na instalação do "software" da autodisciplina no hardware neural mais plástico do ser humano. Com 50 atividades práticas e a exclusiva "Caixa de Ferramentas da Calma", ele ensina a decodificar Medo, Raiva e a Tristeza como mensageiros de poder. Não se trata apenas de educar, mas de uma verdadeira engenharia da alma, garantindo que a criança não seja só uma seguidora de ordens, mas a mestre soberana de seu próprio destino.',
    cover: '/images/ebook-emocoes-em-movimento.jpg',
    oldPrice: 97,
    price: 47.39,
    rating: 4.9,
    reviews: 318,
    pages: 280,
    format: 'E-book PDF | Impresso',
    benefits: [
      {
        icon: 'ri-brain-line',
        title: 'Neurociência Aplicada',
        description: 'Entenda o córtex pré-frontal e como moldar o cérebro infantil nos primeiros 6 anos de vida'
      },
      {
        icon: 'ri-mental-health-line',
        title: 'Wi-Fi da Alma',
        description: 'Use os neurônios-espelho para corregular o sistema nervoso da criança com precisão'
      },
      {
        icon: 'ri-fire-line',
        title: 'Birras em Resiliência',
        description: 'Transforme crises emocionais em oportunidades de construção de autodisciplina'
      },
      {
        icon: 'ri-tools-line',
        title: 'Caixa de Ferramentas da Calma',
        description: '50 atividades práticas e exclusivas para regular emoções em tempo real'
      },
      {
        icon: 'ri-emotion-line',
        title: 'Decodifique as Emoções',
        description: 'Aprenda a interpretar Medo, Raiva e Tristeza como mensageiros de poder e crescimento'
      },
      {
        icon: 'ri-seedling-line',
        title: 'Educação da Vontade',
        description: 'O mapa definitivo para formar indivíduos íntegros, resilientes e soberanos de si'
      }
    ],
    chapters: [
      {
        number: '01',
        title: 'A Fera e o Sábio: O Campo de Batalha Neural de 0 a 6 Anos',
        lessons: 11,
        duration: '44 min'
      },
      {
        number: '02',
        title: 'Wi-Fi da Alma: Neurônios-Espelho e Corregulação',
        lessons: 13,
        duration: '52 min'
      },
      {
        number: '03',
        title: 'Educação da Vontade: Instalando o Software da Autodisciplina',
        lessons: 14,
        duration: '56 min'
      },
      {
        number: '04',
        title: 'A Caixa de Ferramentas da Calma: 50 Atividades Práticas',
        lessons: 16,
        duration: '64 min'
      },
      {
        number: '05',
        title: 'Medo, Raiva e Tristeza como Mensageiros de Poder',
        lessons: 10,
        duration: '40 min'
      },
      {
        number: '06',
        title: 'Engenharia da Alma: Formando Mestres do Próprio Destino',
        lessons: 9,
        duration: '36 min'
      }
    ],
    testimonials: [
      {
        name: 'Daniela Nunes',
        role: 'Pedagoga e Mãe',
        school: 'São Paulo - SP',
        photo: '/images/sergio-barros.jpg',
        text: 'O capítulo do Wi-Fi da Alma mudou completamente como me relaciono com minha filha de 4 anos. As birras diminuíram 90% em três semanas.',
        rating: 5
      },
      {
        name: 'Rafael Teixeira',
        role: 'Pai Solo e Educador',
        school: 'Belo Horizonte - MG',
        photo: '/images/sergio-barros.jpg',
        text: 'Como pai solo, este livro foi uma ancora. A Caixa de Ferramentas da Calma é genial — uso todo dia com meu filho de 3 anos.',
        rating: 5
      },
      {
        name: 'Cristiane Borges',
        role: 'Psicóloga Infantil',
        school: 'Rio de Janeiro - RJ',
        photo: '/images/sergio-barros.jpg',
        text: 'Indico para todos os pais e educadores que atendo. A fundamentação em Winnicott aliada à neurociência prática é simplesmente brilhante.',
        rating: 5
      }
    ],
    faqs: [
      {
        question: 'O livro serve para crianças acima de 6 anos também?',
        answer: 'Este volume é focado nos 0 a 6 anos, fase de maior plasticidade neural. Os fundamentos, porém, são aplicáveis em qualquer idade como base de compreensão emocional.'
      },
      {
        question: 'Preciso ter formação em psicologia para entender o conteúdo?',
        answer: 'Não! O Professor Sergio tem uma habilidade única de traduzir neurociência complexa em linguagem prática e visceral para pais e educadores de qualquer formação.'
      },
      {
        question: 'Quais são as versões disponíveis?',
        answer: 'O livro está disponível em E-book PDF (download imediato), Impresso Capa Comum e Impresso Capa Dura. Escolha o formato que melhor se adapta a você.'
      },
      {
        question: 'As 50 atividades práticas exigem materiais especiais?',
        answer: 'Não! A "Caixa de Ferramentas da Calma" foi projetada para ser acessível com recursos do dia a dia, sem necessidade de materiais especializados.'
      },
      {
        question: 'Como funciona a garantia?',
        answer: 'Garantia incondicional de 7 dias. Se por qualquer motivo não ficar satisfeito, devolvemos 100% do valor sem perguntas.'
      }
    ],
    amazonLink: '#',
    kiwifyLink: '#'
  },
  {
    id: 3,
    slug: 'gestao-escolar',
    title: 'Gestão Escolar Estratégica',
    subtitle: 'Metodologias Comprovadas',
    cover: '/images/sergio-barros.jpg',
    oldPrice: 77,
    price: 29,
    rating: 4.9,
    reviews: 421,
    pages: 312,
    format: 'E-book PDF',
    benefits: [
      {
        icon: 'ri-bar-chart-box-line',
        title: 'KPIs Educacionais',
        description: 'Indicadores-chave para medir o sucesso da sua instituição'
      },
      {
        icon: 'ri-funds-line',
        title: 'Gestão Financeira',
        description: 'Controle orçamentário e estratégias de sustentabilidade'
      },
      {
        icon: 'ri-user-star-line',
        title: 'Captação e Retenção',
        description: 'Técnicas para atrair e manter alunos de qualidade'
      },
      {
        icon: 'ri-team-line',
        title: 'Liderança de Equipes',
        description: 'Como motivar e desenvolver professores e colaboradores'
      },
      {
        icon: 'ri-rocket-line',
        title: 'Inovação Pedagógica',
        description: 'Implementação de metodologias ativas e tecnologia educacional'
      },
      {
        icon: 'ri-file-chart-line',
        title: 'Planejamento Estratégico',
        description: 'Ferramentas para criar e executar planos de crescimento'
      }
    ],
    chapters: [
      {
        number: '01',
        title: 'Fundamentos da Gestão Escolar Moderna',
        lessons: 14,
        duration: '55 min'
      },
      {
        number: '02',
        title: 'Gestão Financeira e Orçamentária',
        lessons: 13,
        duration: '52 min'
      },
      {
        number: '03',
        title: 'Marketing Educacional Estratégico',
        lessons: 11,
        duration: '48 min'
      },
      {
        number: '04',
        title: 'Gestão de Pessoas na Educação',
        lessons: 16,
        duration: '62 min'
      },
      {
        number: '05',
        title: 'Tecnologia e Inovação Pedagógica',
        lessons: 12,
        duration: '50 min'
      }
    ],
    testimonials: [
      {
        name: 'Fernando Costa',
        role: 'Diretor Geral',
        school: 'Colégio Horizonte - SP',
        photo: '/images/sergio-barros.jpg',
        text: 'Implementamos as estratégias do livro e aumentamos nossa receita em 45% em apenas um ano letivo.',
        rating: 5
      },
      {
        name: 'Patricia Mendes',
        role: 'Coordenadora Administrativa',
        school: 'Instituto Educacional - RJ',
        photo: '/images/sergio-barros.jpg',
        text: 'Finalmente um livro que une teoria e prática. Os templates e ferramentas são ouro puro.',
        rating: 5
      },
      {
        name: 'Ricardo Barbosa',
        role: 'Gestor Educacional',
        school: 'Rede de Escolas - MG',
        photo: '/images/sergio-barros.jpg',
        text: 'Gerencio 5 unidades e este livro se tornou a bíblia da nossa equipe de gestão. Indispensável.',
        rating: 5
      }
    ],
    faqs: [
      {
        question: 'Serve para escolas de pequeno porte?',
        answer: 'Absolutamente! As metodologias são escaláveis e há exemplos específicos para escolas de todos os tamanhos, desde 50 até 5000 alunos.'
      },
      {
        question: 'Preciso ter formação em administração?',
        answer: 'Não! O livro foi escrito para educadores que assumiram cargos de gestão. A linguagem é acessível e prática.'
      },
      {
        question: 'Há templates e ferramentas prontas?',
        answer: 'Sim! Você recebe planilhas, checklists e modelos de documentos que pode adaptar para sua realidade.'
      },
      {
        question: 'O conteúdo está atualizado com a BNCC?',
        answer: 'Sim! Todas as estratégias estão alinhadas com a Base Nacional Comum Curricular e legislação vigente.'
      },
      {
        question: 'Qual a garantia?',
        answer: '7 dias de garantia incondicional. Não gostou? Devolvemos 100% do seu investimento.'
      }
    ],
    amazonLink: '#',
    kiwifyLink: '#'
  },
  {
    id: 4,
    slug: 'comunicacao-nao-violenta',
    title: 'Comunicação Não-Violenta na Educação',
    subtitle: 'Transforme Conflitos em Oportunidades',
    cover: '/images/sergio-barros.jpg',
    oldPrice: 67,
    price: 27,
    rating: 4.7,
    reviews: 198,
    pages: 198,
    format: 'E-book PDF',
    benefits: [
      {
        icon: 'ri-chat-heart-line',
        title: 'Diálogo Empático',
        description: 'Técnicas para ouvir e ser ouvido com compaixão'
      },
      {
        icon: 'ri-emotion-line',
        title: 'Gestão de Emoções',
        description: 'Como lidar com raiva, frustração e conflitos de forma saudável'
      },
      {
        icon: 'ri-user-heart-line',
        title: 'Empatia Ativa',
        description: 'Desenvolva a capacidade de se colocar no lugar do outro'
      },
      {
        icon: 'ri-feedback-line',
        title: 'Feedback Construtivo',
        description: 'Aprenda a dar e receber críticas de forma produtiva'
      },
      {
        icon: 'ri-group-line',
        title: 'Mediação de Conflitos',
        description: 'Ferramentas para resolver disputas entre alunos e equipe'
      },
      {
        icon: 'ri-hand-heart-line',
        title: 'Cultura de Paz',
        description: 'Construa um ambiente escolar baseado em respeito e colaboração'
      }
    ],
    chapters: [
      {
        number: '01',
        title: 'Fundamentos da CNV',
        lessons: 8,
        duration: '32 min'
      },
      {
        number: '02',
        title: 'Os 4 Componentes da CNV',
        lessons: 10,
        duration: '42 min'
      },
      {
        number: '03',
        title: 'CNV na Sala de Aula',
        lessons: 9,
        duration: '38 min'
      },
      {
        number: '04',
        title: 'Mediação de Conflitos Escolares',
        lessons: 7,
        duration: '30 min'
      },
      {
        number: '05',
        title: 'CNV com Pais e Responsáveis',
        lessons: 6,
        duration: '28 min'
      }
    ],
    testimonials: [
      {
        name: 'Luciana Martins',
        role: 'Professora de Ensino Fundamental',
        school: 'Escola Municipal - SP',
        photo: '/images/sergio-barros.jpg',
        text: 'Minha sala de aula se transformou. Os conflitos diminuíram 80% e os alunos aprenderam a se expressar melhor.',
        rating: 5
      },
      {
        name: 'Marcos Silva',
        role: 'Coordenador Pedagógico',
        school: 'Colégio Integrado - RJ',
        photo: '/images/sergio-barros.jpg',
        text: 'Implementamos a CNV em toda a escola. O clima organizacional melhorou drasticamente.',
        rating: 5
      },
      {
        name: 'Beatriz Oliveira',
        role: 'Psicóloga Escolar',
        school: 'Instituto Educacional - MG',
        photo: '/images/sergio-barros.jpg',
        text: 'Como psicóloga, recomendo este livro para todos os educadores. É transformador.',
        rating: 5
      }
    ],
    faqs: [
      {
        question: 'Funciona com alunos de todas as idades?',
        answer: 'Sim! O livro traz adaptações da CNV para educação infantil, fundamental e ensino médio.'
      },
      {
        question: 'Preciso fazer um curso presencial de CNV antes?',
        answer: 'Não! O livro é autoexplicativo e traz exercícios práticos para você começar imediatamente.'
      },
      {
        question: 'Posso usar com minha própria família?',
        answer: 'Com certeza! As técnicas de CNV são universais e funcionam em qualquer contexto de relacionamento.'
      },
      {
        question: 'Quanto tempo leva para ver resultados?',
        answer: 'Muitos educadores relatam mudanças perceptíveis já nas primeiras semanas de aplicação.'
      },
      {
        question: 'Há garantia de devolução?',
        answer: 'Sim! 7 dias de garantia incondicional. Não gostou? Devolvemos 100% do valor.'
      }
    ],
    amazonLink: '#',
    kiwifyLink: '#'
  },
  {
    id: 5,
    slug: 'inteligencia-emocional',
    title: 'Inteligência Emocional para Pais',
    subtitle: 'Criando Filhos Resilientes',
    cover: '/images/sergio-barros.jpg',
    oldPrice: 72,
    price: 28,
    rating: 4.8,
    reviews: 267,
    pages: 223,
    format: 'E-book PDF',
    benefits: [
      {
        icon: 'ri-brain-line',
        title: 'Autoconhecimento',
        description: 'Entenda suas próprias emoções para educar melhor'
      },
      {
        icon: 'ri-shield-user-line',
        title: 'Resiliência Infantil',
        description: 'Desenvolva a capacidade dos seus filhos de superar desafios'
      },
      {
        icon: 'ri-emotion-happy-line',
        title: 'Regulação Emocional',
        description: 'Ensine seus filhos a lidar com frustrações e ansiedade'
      },
      {
        icon: 'ri-user-smile-line',
        title: 'Autoestima Saudável',
        description: 'Construa uma base sólida de confiança e amor-próprio'
      },
      {
        icon: 'ri-parent-line',
        title: 'Parentalidade Consciente',
        description: 'Eduque com presença, empatia e inteligência emocional'
      },
      {
        icon: 'ri-heart-pulse-line',
        title: 'Saúde Mental Familiar',
        description: 'Crie um ambiente emocionalmente seguro e acolhedor'
      }
    ],
    chapters: [
      {
        number: '01',
        title: 'Os 5 Pilares da Inteligência Emocional',
        lessons: 11,
        duration: '45 min'
      },
      {
        number: '02',
        title: 'Autoconhecimento Parental',
        lessons: 9,
        duration: '38 min'
      },
      {
        number: '03',
        title: 'Desenvolvendo IE nas Crianças',
        lessons: 13,
        duration: '52 min'
      },
      {
        number: '04',
        title: 'Lidando com Birras e Frustrações',
        lessons: 10,
        duration: '42 min'
      },
      {
        number: '05',
        title: 'Construindo Resiliência Familiar',
        lessons: 8,
        duration: '35 min'
      }
    ],
    testimonials: [
      {
        name: 'Renata Campos',
        role: 'Mãe de 2 Filhos',
        school: 'São Paulo - SP',
        photo: '/images/sergio-barros.jpg',
        text: 'Aprendi a lidar com as birras dos meus filhos de forma muito mais tranquila. Mudou nossa dinâmica familiar.',
        rating: 5
      },
      {
        name: 'André Carvalho',
        role: 'Pai e Psicólogo',
        school: 'Rio de Janeiro - RJ',
        photo: '/images/sergio-barros.jpg',
        text: 'Como profissional da área, posso afirmar: este é o melhor guia prático de IE parental que já li.',
        rating: 5
      },
      {
        name: 'Mariana Santos',
        role: 'Mãe Solo',
        school: 'Belo Horizonte - MG',
        photo: '/images/sergio-barros.jpg',
        text: 'Me ajudou a criar meu filho com mais segurança e menos culpa. Sou muito grata por este livro.',
        rating: 5
      }
    ],
    faqs: [
      {
        question: 'Funciona para crianças de todas as idades?',
        answer: 'Sim! O livro traz estratégias adaptadas desde bebês até adolescentes, com exemplos práticos para cada fase.'
      },
      {
        question: 'E se eu não tiver inteligência emocional desenvolvida?',
        answer: 'Perfeito! O livro começa pelo autoconhecimento parental. Você vai se desenvolver junto com seus filhos.'
      },
      {
        question: 'Preciso de conhecimento em psicologia?',
        answer: 'Não! A linguagem é acessível e prática. Você vai aprender técnicas aplicáveis no dia a dia.'
      },
      {
        question: 'Posso aplicar se meu filho já é adolescente?',
        answer: 'Sim! Nunca é tarde para desenvolver inteligência emocional. Há capítulos específicos para adolescentes.'
      },
      {
        question: 'Qual a garantia?',
        answer: '7 dias de garantia incondicional. Não gostou? Devolvemos 100% do seu investimento.'
      }
    ],
    amazonLink: '#',
    kiwifyLink: '#'
  },
  {
    id: 6,
    slug: 'disciplina-positiva',
    title: 'Disciplina Positiva na Prática',
    subtitle: 'Educar sem Punir',
    cover: '/images/sergio-barros.jpg',
    oldPrice: 82,
    price: 31,
    rating: 4.9,
    reviews: 356,
    pages: 267,
    format: 'E-book PDF',
    benefits: [
      {
        icon: 'ri-scales-line',
        title: 'Firmeza com Gentileza',
        description: 'Aprenda a estabelecer limites sem autoritarismo'
      },
      {
        icon: 'ri-user-heart-line',
        title: 'Respeito Mútuo',
        description: 'Construa relações baseadas em dignidade e cooperação'
      },
      {
        icon: 'ri-lightbulb-line',
        title: 'Soluções Colaborativas',
        description: 'Envolva as crianças na resolução de problemas'
      },
      {
        icon: 'ri-emotion-happy-line',
        title: 'Consequências Naturais',
        description: 'Substitua punições por aprendizados significativos'
      },
      {
        icon: 'ri-team-line',
        title: 'Reuniões Familiares',
        description: 'Ferramentas para criar momentos de conexão e decisão em família'
      },
      {
        icon: 'ri-plant-line',
        title: 'Autonomia e Responsabilidade',
        description: 'Desenvolva a independência e senso de contribuição dos filhos'
      }
    ],
    chapters: [
      {
        number: '01',
        title: 'Fundamentos da Disciplina Positiva',
        lessons: 12,
        duration: '48 min'
      },
      {
        number: '02',
        title: 'Firmeza e Gentileza na Prática',
        lessons: 14,
        duration: '55 min'
      },
      {
        number: '03',
        title: 'Consequências vs. Punições',
        lessons: 10,
        duration: '42 min'
      },
      {
        number: '04',
        title: 'Reuniões Familiares Efetivas',
        lessons: 8,
        duration: '35 min'
      },
      {
        number: '05',
        title: 'Desenvolvendo Autonomia',
        lessons: 11,
        duration: '45 min'
      }
    ],
    testimonials: [
      {
        name: 'Paula Ribeiro',
        role: 'Mãe de 3 Filhos',
        school: 'São Paulo - SP',
        photo: '/images/sergio-barros.jpg',
        text: 'Parei de gritar e punir. Agora meus filhos colaboram porque querem, não por medo. Vida transformada!',
        rating: 5
      },
      {
        name: 'Thiago Mendes',
        role: 'Pai e Educador',
        school: 'Rio de Janeiro - RJ',
        photo: '/images/sergio-barros.jpg',
        text: 'Como professor e pai, aplico a disciplina positiva em casa e na escola. Os resultados são incríveis.',
        rating: 5
      },
      {
        name: 'Fernanda Costa',
        role: 'Psicóloga Infantil',
        school: 'Belo Horizonte - MG',
        photo: '/images/sergio-barros.jpg',
        text: 'Recomendo este livro para todos os pais que atendo. É o melhor guia prático de disciplina positiva.',
        rating: 5
      }
    ],
    faqs: [
      {
        question: 'Disciplina positiva funciona com crianças desafiadoras?',
        answer: 'Sim! Na verdade, é especialmente efetiva com crianças que não respondem bem a punições tradicionais.'
      },
      {
        question: 'Não é permissividade?',
        answer: 'Não! Disciplina positiva é firme E gentil. Há limites claros, mas sem autoritarismo ou punições.'
      },
      {
        question: 'Quanto tempo leva para ver mudanças?',
        answer: 'Muitos pais relatam mudanças em 2-3 semanas. Mas é uma jornada de transformação contínua.'
      },
      {
        question: 'Posso aplicar se já uso métodos tradicionais?',
        answer: 'Sim! O livro ensina a transição gradual de punições para consequências naturais e lógicas.'
      },
      {
        question: 'Há garantia?',
        answer: '7 dias de garantia incondicional. Não gostou? Devolvemos 100% do seu investimento.'
      }
    ],
    amazonLink: '#',
    kiwifyLink: '#'
  }
];

export const getBookBySlug = (slug: string): Book | undefined => {
  return booksData.find(book => book.slug === slug);
};

export const getBookById = (id: number): Book | undefined => {
  return booksData.find(book => book.id === id);
};